<template>
  <form class="vform">
    <slot />
  </form>
</template>
<script>
import {getPropByPath, setValForAllKeys} from './utils';
export default {
  name: 'VForm',
  props: {
    model: Object,
    errors: Object,
  },
  data() {
    return {
      fields: [],
    };
  },
  provide() {
    return {
      VForm: this,
    };
  },
  created() {},
  mounted() {},
  methods: {
    addField(el) {
      this.fields.push(el);
    },
    resetFields() {
      if (!this.model) {
        console.warn('FORM_WARN model is required for resetFields to work.');
        return;
      }
      const clearedVal = setValForAllKeys(this.model, '');
      this.model = Object.assign(this.model, clearedVal);
    },
  },
};
</script>
<style scoped></style>
